import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/orderings/store/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const store = {
  get: apiPathFunc(pathBase),
} as const;
